//src/Components/EmojiPicker/SearchEmojis.ts
import { Emojis } from './data';

const searchEmojis = (search: string) => {
  return Object.values(Emojis.emojis).filter((emoji) =>
    [emoji.name, ...emoji.keywords].some((k) => k.includes(search)),
  );
};

export default searchEmojis;
